const misc = {
  testimonial: 'https://assets.kinside.com/static/web/kinside_app/testimonial-photo.png',
  avatar: 'https://assets.kinside.com/static/web/kinside_app/placeholder-avatar_2x.png',
  naviaLogo: 'https://assets.kinside.com/static/web/navia-logo.png',
  wave: 'https://assets.kinside.com/static/web/kinside_app/mask-group-wave.png',
};

const kinsideLogo = {
  dark: 'https://assets.kinside.com/static/web/kinside_logo/dark.svg',
  wordLight: 'https://assets.kinside.com/static/web/kinside_logo/kinside-word-light.svg',
  wordDark: 'https://assets.kinside.com/static/web/kinside_logo/kinside-word-dark.svg',
  poweredByUsLight: 'https://assets.kinside.com/static/web/kinside_logo/powered-by-us-light.svg',
  poweredByUsDark: 'https://assets.kinside.com/static/web/kinside_logo/powered-by-us-dark.svg',
};

const illustrations = {
  block: 'https://assets.kinside.com/static/web/kinside_app/illustration-block1.png',
  block4: 'https://assets.kinside.com/static/web/static_pages/employers/illustration-block-4.png',
  block5: 'https://assets.kinside.com/static/web/static_pages/employers/illustration-block5.png',
  boyGirl: 'https://assets.kinside.com/static/web/illustration-boygirl.png',
  boyGirl2: 'https://assets.kinside.com/static/web/illustration-boygirl.png',
  chalkboard: 'https://assets.kinside.com/static/web/kinside_app/illustration-chalkboard.png',
  child1: 'https://assets.kinside.com/static/web/illustration-child1.png',
  child2: 'https://assets.kinside.com/static/web/illustration-child2.png',
  employee: 'https://assets.kinside.com/static/web/illustration-employee.png',
  girl: 'https://assets.kinside.com/static/web/illustration-girl.png',
  mailbox: 'https://assets.kinside.com/static/web/illustration-mailbox.svg',
  map: 'https://assets.kinside.com/static/web/kinside_app/illustration-map.png',
  momDaughter: 'https://assets.kinside.com/static/web/illustration-mom-daughter.png',
  momDaughter2: 'https://assets.kinside.com/static/web/illustration-mom-daughter2.png',
  moon: 'https://assets.kinside.com/static/web/illustration-moon.png',
  plants: 'https://assets.kinside.com/static/web/illustration-plants.png',
  search: 'https://assets.kinside.com/static/web/illustration-search.png',
  sun: 'https://assets.kinside.com/static/web/illustration-sun.png',
  tada: 'https://assets.kinside.com/static/web/illustration-tada.svg',
  toys: 'https://assets.kinside.com/static/web/illustration-toys3.png',
  trees: 'https://assets.kinside.com/static/web/kinside_app/illustration-trees.png',
  warning: 'https://assets.kinside.com/static/web/warn.png',
};

const facilityPlaceholder = [
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-19_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-18_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-15_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-14_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-13_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-12_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-11_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-9_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-7_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-6_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-5_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-4_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-3_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-2_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-1_2x.webp',
  'https://assets.kinside.com/static/web/kinside_app/facility-placeholders/facility-placeholder-0_2x.webp',
];

const marker = {
  location: 'https://assets.kinside.com/static/web/kinside_app/Marker/Location.svg',
  specific: {
    match: {
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Match/Hovered.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Match/Viewed.svg',
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Match/Default.svg',
    },
    saved: {
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Saved/Hovered.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Saved/Viewed.svg',
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Saved/Default.svg',
    },
    disabled: {
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Disabled/Hovered.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Disabled/Viewed.svg',
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Disabled/Default.svg',
    },
    favorited: {
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Favorited/Default.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Favorited/Viewed.svg',
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Favorited/Hovered.svg',
    },
    ignored: {
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Ignored/Viewed.svg',
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Ignored/Default.svg',
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Ignored/Hovered.svg',
    },
    nonPartner: {
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Non-partner/Default.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Non-partner/Viewed.svg',
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Non-partner/Hovered.svg',
    },
    offer: {
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Offer/Default.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Offer/Viewed.svg',
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Offer/Hovered.svg',
    },
    partner: {
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Partner/Default.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Partner/Viewed.svg',
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Partner/Hovered.svg',
    },
    payingPartner: {
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Paying%20Partner/Hovered.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Paying%20Partner/Viewed.svg',
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Paying%20Partner/Default.svg',
    },
  },
  zipBased: {
    nonPartner: {
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Non-partner%20%28Zip%20Only%29/Viewed.svg',
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Non-partner%20%28Zip%20Only%29/Default.svg',
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Non-partner%20%28Zip%20Only%29/Hovered.svg',
    },
    partner: {
      hovered: 'https://assets.kinside.com/static/web/kinside_app/Marker/Partner%20%28Zip%20Only%29/Hovered.svg',
      viewed: 'https://assets.kinside.com/static/web/kinside_app/Marker/Partner%20%28Zip%20Only%29/Viewed.svg',
      default: 'https://assets.kinside.com/static/web/kinside_app/Marker/Partner%20%28Zip%20Only%29/Default.svg',
    },
  },

};

const marketingMaterials = {
  generalOnePager: 'https://assets.kinside.com/static/web/marketing_materials/kinside-general-one-pager.png',
  parentalOnePager: 'https://assets.kinside.com/static/web/marketing_materials/kinside-parental-leave-one-pager.png',
  presentation: 'https://assets.kinside.com/static/web/marketing_materials/kinside-presentation-slides.png',
  childCareProfile: 'https://assets.kinside.com/static/web/marketing_materials/child-care-provider.png',
  familySearch: 'https://assets.kinside.com/static/web/marketing_materials/family-search.png',
  documentParents: 'https://assets.kinside.com/static/web/marketing_materials/documents/Kinside_-_For_Parents.pdf',
  documentIntranet: 'https://assets.kinside.com/static/web/marketing_materials/documents/Kinside_-_Intranet_Overview.pdf',
  documentParental: 'https://assets.kinside.com/static/web/marketing_materials/documents/Kinside_-_Parental_Leave.pdf',
};

export {
  misc,
  illustrations,
  facilityPlaceholder,
  marker,
  kinsideLogo,
  marketingMaterials,
};
